const stats = [
  { value: "200+", label: "Countries Covered" },
  { value: "99.99%", label: "Delivery Uptime" },
  { value: "1B+", label: "Messages Monthly" },
  { value: "18+", label: "Years of Expertise" },
];

const StatsBar = () => (
  <section className="section-shell pt-[64px] md:pt-[80px]">
    <div className="mx-auto max-w-[1200px] rounded-[24px] bg-[#0f1623] px-6 py-12 md:px-12 md:py-14">
      <div className="grid grid-cols-2 gap-y-10 md:grid-cols-4 md:gap-0">
        {stats.map((s, i) => (
          <div
            key={s.label}
            className={`text-center ${
              i > 0 ? "md:border-l md:border-white/15" : ""
            }`}
          >
            <div className="font-display text-[36px] font-bold leading-none text-white md:text-[44px]">
              {s.value}
            </div>
            <div className="mt-3 text-[13px] font-medium uppercase tracking-wider text-white/70 md:text-[13.5px]">
              {s.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default StatsBar;